import React, { useCallback } from 'react';
import {
  ReactFlow,
  MiniMap,
  Controls,
  Background,
  useNodesState,
  useEdgesState,
  addEdge,
} from '@xyflow/react';
import '@xyflow/react/dist/style.css';
import { Box, Paper, Typography } from '@mui/material';

const initialNodes = [
  {
    id: '1',
    type: 'input',
    data: {
      label: (
        <div style={{ padding: '16px' }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            marginBottom: '12px'
          }}>
            <div style={{
              fontSize: '16px',
              fontWeight: '600',
              color: '#1a1a1a',
              letterSpacing: '-0.01em',
              flex: 1
            }}>
              E-Book-Aufbereitung
            </div>
            <div style={{
              fontSize: '11px',
              fontWeight: '600',
              color: '#ef4444',
              background: '#fee2e2',
              padding: '4px 8px',
              borderRadius: '4px',
              whiteSpace: 'nowrap',
              marginLeft: '8px'
            }}>
              30.1
            </div>
          </div>
          <div style={{
            fontSize: '11px',
            color: '#6b7280',
            fontWeight: '500',
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            marginBottom: '10px'
          }}>
            Beteiligt: Michael
          </div>
          <div style={{ fontSize: '13px', color: '#374151', lineHeight: '1.5' }}>
            Legt zu chunkende Dateien aus PS 1 in IN-Ordner ab
          </div>
        </div>
      )
    },
    position: { x: 0, y: 150 },
    style: {
      background: 'white',
      border: '2px solid #e5e7eb',
      borderRadius: '12px',
      width: 300,
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
    },
  },
  {
    id: '2',
    data: {
      label: (
        <div style={{ padding: '16px' }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            marginBottom: '12px'
          }}>
            <div style={{
              fontSize: '16px',
              fontWeight: '600',
              color: '#1a1a1a',
              letterSpacing: '-0.01em',
              flex: 1
            }}>
              Erstellung der Chunks
            </div>
            <div style={{
              fontSize: '11px',
              fontWeight: '600',
              color: '#ea580c',
              background: '#ffedd5',
              padding: '4px 8px',
              borderRadius: '4px',
              whiteSpace: 'nowrap',
              marginLeft: '8px'
            }}>
              1.2 - 2.2
            </div>
          </div>
          <div style={{
            fontSize: '11px',
            color: '#6b7280',
            fontWeight: '500',
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            marginBottom: '10px'
          }}>
            Beteiligt: Joris, Pia, Moritz
          </div>
          <div style={{ fontSize: '13px', color: '#374151', lineHeight: '1.6' }}>
            • Lädt E-Books aus IN-Ordner<br/>
            • Check Chunk-Grenzen & Titel<br/>
            • Prüft Beiträger-Zuordnung<br/>
            • Prüft Sprachzuordnung<br/>
            • Prüft Sichtbarkeit<br/>
            • Lädt Paket in CHECK-Ordner
          </div>
        </div>
      )
    },
    position: { x: 400, y: 150 },
    style: {
      background: 'white',
      border: '2px solid #e5e7eb',
      borderRadius: '12px',
      width: 300,
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
    },
  },
  {
    id: '3',
    data: {
      label: (
        <div style={{ padding: '16px' }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            marginBottom: '12px'
          }}>
            <div style={{
              fontSize: '16px',
              fontWeight: '600',
              color: '#1a1a1a',
              letterSpacing: '-0.01em',
              flex: 1
            }}>
              Qualitätssicherung
            </div>
            <div style={{
              fontSize: '11px',
              fontWeight: '600',
              color: '#d97706',
              background: '#fef3c7',
              padding: '4px 8px',
              borderRadius: '4px',
              whiteSpace: 'nowrap',
              marginLeft: '8px'
            }}>
              2.2 - 3.2
            </div>
          </div>
          <div style={{
            fontSize: '11px',
            color: '#6b7280',
            fontWeight: '500',
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            marginBottom: '10px'
          }}>
            Beteiligt: Jürgen, Michael
          </div>
          <div style={{ fontSize: '13px', color: '#374151', lineHeight: '1.6' }}>
            • Check Chunkgrenzen & -anzahl<br/>
            • Dateinamen prüfen<br/>
            • XML validieren<br/>
            • Namen stichprobenartig checken<br/>
            • Sprachen stichprobenartig checken
          </div>
          <div style={{
            fontSize: '11px',
            marginTop: '10px',
            fontStyle: 'italic',
            color: '#9ca3af',
            borderTop: '1px solid #f3f4f6',
            paddingTop: '8px'
          }}>
            Max. 3h für alle Pakete (6min/Paket)
          </div>
        </div>
      )
    },
    position: { x: 800, y: 150 },
    style: {
      background: 'white',
      border: '2px solid #e5e7eb',
      borderRadius: '12px',
      width: 300,
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
    },
  },
  {
    id: 'qa-issues',
    data: {
      label: (
        <div style={{ padding: '16px' }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            marginBottom: '12px'
          }}>
            <div style={{
              fontSize: '16px',
              fontWeight: '600',
              color: '#1a1a1a',
              letterSpacing: '-0.01em',
              flex: 1
            }}>
              Umgang mit Problemen
            </div>
            <div style={{
              fontSize: '11px',
              fontWeight: '600',
              color: '#dc2626',
              background: '#fee2e2',
              padding: '4px 8px',
              borderRadius: '4px',
              whiteSpace: 'nowrap',
              marginLeft: '8px'
            }}>
              Bei Bedarf
            </div>
          </div>
          <div style={{
            fontSize: '11px',
            color: '#6b7280',
            fontWeight: '500',
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            marginBottom: '10px'
          }}>
            Beteiligt: Jürgen, Michael
          </div>
          <div style={{ fontSize: '13px', color: '#374151', lineHeight: '1.6' }}>
            Sobald einer der Schritte nicht durchgeführt werden konnte oder die Anforderungen an die Qualität nicht erfüllt wurden, wird ein Issue erstellt und dies an die Person adressiert, die das Chunk-Paket erstellt hat.
          </div>
        </div>
      )
    },
    position: { x: 800, y: 500 },
    style: {
      background: '#fef2f2',
      border: '2px solid #fecaca',
      borderRadius: '12px',
      width: 300,
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
    },
  },
  {
    id: '4',
    data: {
      label: (
        <div style={{ padding: '16px' }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            marginBottom: '12px'
          }}>
            <div style={{
              fontSize: '16px',
              fontWeight: '600',
              color: '#1a1a1a',
              letterSpacing: '-0.01em',
              flex: 1
            }}>
              Übergabe an ERNA
            </div>
            <div style={{
              fontSize: '11px',
              fontWeight: '600',
              color: '#059669',
              background: '#d1fae5',
              padding: '4px 8px',
              borderRadius: '4px',
              whiteSpace: 'nowrap',
              marginLeft: '8px'
            }}>
              3.2
            </div>
          </div>
          <div style={{
            fontSize: '11px',
            color: '#6b7280',
            fontWeight: '500',
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            marginBottom: '10px'
          }}>
            Beteiligt: Jürgen, Michael
          </div>
          <div style={{ fontSize: '13px', color: '#374151', lineHeight: '1.5' }}>
            Fertige Chunk-Pakete werden im OUT-Ordner abgelegt
          </div>
        </div>
      )
    },
    position: { x: 1200, y: 150 },
    style: {
      background: 'white',
      border: '2px solid #e5e7eb',
      borderRadius: '12px',
      width: 300,
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
    },
  },
  {
    id: '5',
    data: {
      label: (
        <div style={{ padding: '16px' }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            marginBottom: '12px'
          }}>
            <div style={{
              fontSize: '16px',
              fontWeight: '600',
              color: '#1a1a1a',
              letterSpacing: '-0.01em',
              flex: 1
            }}>
              Vorgehen in der ERNA
            </div>
            <div style={{
              fontSize: '11px',
              fontWeight: '600',
              color: '#0891b2',
              background: '#cffafe',
              padding: '4px 8px',
              borderRadius: '4px',
              whiteSpace: 'nowrap',
              marginLeft: '8px'
            }}>
              3.2 - 5.2
            </div>
          </div>
          <div style={{
            fontSize: '11px',
            color: '#6b7280',
            fontWeight: '500',
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            marginBottom: '10px'
          }}>
            Beteiligt: ERNA / Alex
          </div>
          <div style={{ fontSize: '13px', color: '#374151', lineHeight: '1.6' }}>
            • Chunk-Pakete aus OUT-Ordner ziehen<br/>
            • XML in die Datenbank importieren und die zugehörigen PDF-Chunks in die jeweiligen Archiv Verzeichnisse verschieben
          </div>
        </div>
      )
    },
    position: { x: 1600, y: 150 },
    style: {
      background: 'white',
      border: '2px solid #e5e7eb',
      borderRadius: '12px',
      width: 300,
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
    },
  },
  {
    id: '6',
    data: {
      label: (
        <div style={{ padding: '16px' }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            marginBottom: '12px'
          }}>
            <div style={{
              fontSize: '16px',
              fontWeight: '600',
              color: '#1a1a1a',
              letterSpacing: '-0.01em',
              flex: 1
            }}>
              Übergabe an Nomos
            </div>
            <div style={{
              fontSize: '11px',
              fontWeight: '600',
              color: '#7c3aed',
              background: '#ede9fe',
              padding: '4px 8px',
              borderRadius: '4px',
              whiteSpace: 'nowrap',
              marginLeft: '8px'
            }}>
              5.2
            </div>
          </div>
          <div style={{
            fontSize: '11px',
            color: '#6b7280',
            fontWeight: '500',
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            marginBottom: '10px'
          }}>
            Beteiligt: ERNA/Alex, Kai, Moritz
          </div>
          <div style={{ fontSize: '13px', color: '#374151', lineHeight: '1.5' }}>
            • Pro Chunk-Paket eine Nomos-konforme XML-Datei mit allen benötigten Metadaten (Chunktool-Daten + Klopotek Daten) erstellen und diese mit den Covern und den PDF-Chunks in ein ZIP Archiv verpacken. <br/>
            • Moritz und Kai prüfen das Paket nochmals
          </div>
        </div>
      )
    },
    position: { x: 2000, y: 150 },
    style: {
      background: 'white',
      border: '2px solid #e5e7eb',
      borderRadius: '12px',
      width: 300,
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
    },
  },
  {
    id: '7',
    type: 'output',
    data: {
      label: (
        <div style={{ padding: '16px' }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            marginBottom: '12px'
          }}>
            <div style={{
              fontSize: '16px',
              fontWeight: '600',
              color: '#1a1a1a',
              letterSpacing: '-0.01em',
              flex: 1
            }}>
              Abschluss
            </div>
            <div style={{
              fontSize: '11px',
              fontWeight: '600',
              color: '#16a34a',
              background: '#dcfce7',
              padding: '4px 8px',
              borderRadius: '4px',
              whiteSpace: 'nowrap',
              marginLeft: '8px'
            }}>
              5.2
            </div>
          </div>
          <div style={{
            fontSize: '11px',
            color: '#6b7280',
            fontWeight: '500',
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            marginBottom: '10px'
          }}>
            Beteiligt: Alle
          </div>
          <div style={{ fontSize: '13px', color: '#374151', lineHeight: '1.5' }}>
            Das Chunken von PS1 ist abgeschlossen!
          </div>
        </div>
      )
    },
    position: { x: 2400, y: 150 },
    style: {
      background: '#f0fdf4',
      border: '2px solid #86efac',
      borderRadius: '12px',
      width: 300,
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
    },
  },
  // Side note nodes for folder structure
  {
    id: 'folder-in',
    data: {
      label: (
        <div style={{ padding: '12px' }}>
          <div style={{
            fontSize: '12px',
            fontWeight: '600',
            color: '#1f2937',
            marginBottom: '6px'
          }}>
            📁 IN-Ordner
          </div>
          <div style={{ fontSize: '11px', color: '#6b7280', fontFamily: 'monospace' }}>
            {'/'}{'/'} public/chunk_tool_daten/IN
          </div>
          <div style={{ fontSize: '11px', color: '#9ca3af', marginTop: '4px' }}>
            E-Books nach Aufbereitung
          </div>
        </div>
      )
    },
    position: { x: 50, y: 600 },
    style: {
      background: '#fafafa',
      border: '1px dashed #d1d5db',
      borderRadius: '8px',
      width: 200
    },
  },
  {
    id: 'folder-check',
    data: {
      label: (
        <div style={{ padding: '12px' }}>
          <div style={{
            fontSize: '12px',
            fontWeight: '600',
            color: '#1f2937',
            marginBottom: '6px'
          }}>
            📁 CHECK-Ordner
          </div>
          <div style={{ fontSize: '11px', color: '#6b7280', fontFamily: 'monospace' }}>
            {'/'}{'/'} public/chunk_tool_daten/CHECK
          </div>
          <div style={{ fontSize: '11px', color: '#9ca3af', marginTop: '4px' }}>
            Chunk-Pakete nach Erstellung
          </div>
        </div>
      )
    },
    position: { x: 450, y: 600 },
    style: {
      background: '#fafafa',
      border: '1px dashed #d1d5db',
      borderRadius: '8px',
      width: 200
    },
  },
  {
    id: 'folder-out',
    data: {
      label: (
        <div style={{ padding: '12px' }}>
          <div style={{
            fontSize: '12px',
            fontWeight: '600',
            color: '#1f2937',
            marginBottom: '6px'
          }}>
            📁 OUT-Ordner
          </div>
          <div style={{ fontSize: '11px', color: '#6b7280', fontFamily: 'monospace' }}>
            {'/'}{'/'} public/chunk_tool_daten/OUT
          </div>
          <div style={{ fontSize: '11px', color: '#9ca3af', marginTop: '4px' }}>
            Qualitätsgeprüfte Chunk-Pakete
          </div>
        </div>
      )
    },
    position: { x: 1250, y: 600 },
    style: {
      background: '#fafafa',
      border: '1px dashed #d1d5db',
      borderRadius: '8px',
      width: 200
    },
  },
];

const initialEdges = [
  {
    id: 'e1-2',
    source: '1',
    target: '2',
    type: 'smoothstep',
    animated: false,
    style: { stroke: '#9ca3af', strokeWidth: 2 },
    label: 'Alle E-Books im IN-Ordner (30.1)',
    labelStyle: { fill: '#6b7280', fontSize: '12px', fontWeight: 500 },
    labelBgStyle: { fill: '#ffffff', fillOpacity: 0.95 },
    labelBgPadding: [8, 4],
    labelBgBorderRadius: 4
  },
  {
    id: 'e2-3',
    source: '2',
    target: '3',
    type: 'smoothstep',
    animated: false,
    style: { stroke: '#9ca3af', strokeWidth: 2 },
    label: 'Chunk-Paket pro Werk (2.2)',
    labelStyle: { fill: '#6b7280', fontSize: '12px', fontWeight: 500 },
    labelBgStyle: { fill: '#ffffff', fillOpacity: 0.95 },
    labelBgPadding: [8, 4],
    labelBgBorderRadius: 4
  },
  {
    id: 'e3-4',
    source: '3',
    target: '4',
    type: 'smoothstep',
    animated: false,
    style: { stroke: '#9ca3af', strokeWidth: 2 },
    label: 'Qualitätsgeprüft (3.2)',
    labelStyle: { fill: '#6b7280', fontSize: '12px', fontWeight: 500 },
    labelBgStyle: { fill: '#ffffff', fillOpacity: 0.95 },
    labelBgPadding: [8, 4],
    labelBgBorderRadius: 4
  },
  // Problem handling branch
  {
    id: 'e3-qa-issues',
    source: '3',
    target: 'qa-issues',
    type: 'smoothstep',
    animated: false,
    style: { stroke: '#ef4444', strokeWidth: 2, strokeDasharray: '5,5' },
    label: 'Probleme gefunden',
    labelStyle: { fill: '#dc2626', fontSize: '12px', fontWeight: 500 },
    labelBgStyle: { fill: '#ffffff', fillOpacity: 0.95 },
    labelBgPadding: [8, 4],
    labelBgBorderRadius: 4
  },
  {
    id: 'eqa-issues-2',
    source: 'qa-issues',
    target: '2',
    type: 'smoothstep',
    animated: false,
    style: { stroke: '#ef4444', strokeWidth: 2, strokeDasharray: '5,5' },
    label: 'Issue an Ersteller',
    labelStyle: { fill: '#dc2626', fontSize: '12px', fontWeight: 500 },
    labelBgStyle: { fill: '#ffffff', fillOpacity: 0.95 },
    labelBgPadding: [8, 4],
    labelBgBorderRadius: 4
  },
  {
    id: 'e4-5',
    source: '4',
    target: '5',
    type: 'smoothstep',
    animated: false,
    style: { stroke: '#9ca3af', strokeWidth: 2 }
  },
  {
    id: 'e5-6',
    source: '5',
    target: '6',
    type: 'smoothstep',
    animated: false,
    style: { stroke: '#9ca3af', strokeWidth: 2 },
    label: 'Finalisierte Pakete',
    labelStyle: { fill: '#6b7280', fontSize: '12px', fontWeight: 500 },
    labelBgStyle: { fill: '#ffffff', fillOpacity: 0.95 },
    labelBgPadding: [8, 4],
    labelBgBorderRadius: 4
  },
  {
    id: 'e6-7',
    source: '6',
    target: '7',
    type: 'smoothstep',
    animated: false,
    style: { stroke: '#86efac', strokeWidth: 2 }
  },
  // Connections to folder notes
  {
    id: 'e1-folder-in',
    source: '1',
    target: 'folder-in',
    type: 'step',
    style: { stroke: '#d1d5db', strokeWidth: 1, strokeDasharray: '5,5' },
    animated: false
  },
  {
    id: 'e2-folder-check',
    source: '2',
    target: 'folder-check',
    type: 'step',
    style: { stroke: '#d1d5db', strokeWidth: 1, strokeDasharray: '5,5' },
    animated: false
  },
  {
    id: 'e4-folder-out',
    source: '4',
    target: 'folder-out',
    type: 'step',
    style: { stroke: '#d1d5db', strokeWidth: 1, strokeDasharray: '5,5' },
    animated: false
  },
];

function ProcessFlow() {
  const [nodes, , onNodesChange] = useNodesState(initialNodes);
  const [edges, setEdges, onEdgesChange] = useEdgesState(initialEdges);

  const onConnect = useCallback(
    (params) => setEdges((eds) => addEdge(params, eds)),
    [setEdges],
  );

  return (
    <Box sx={{ height: '100vh', width: '100%', display: 'flex', flexDirection: 'column', bgcolor: '#fafafa' }}>
      <Paper
        elevation={0}
        sx={{
          p: 3,
          m: 2,
          mb: 0,
          background: 'white',
          borderBottom: '1px solid #e5e7eb'
        }}
      >
        <Typography variant="h4" sx={{ color: '#1a1a1a', fontWeight: '600', letterSpacing: '-0.02em' }}>
          Internes Chunken - Produktionsablauf PS 1/26
        </Typography>
        <Typography variant="body2" sx={{ color: '#6b7280', mt: 1.5 }}>
          Übergang von Test-Phase zu Produktiv anhand von Prod.set 1/26
        </Typography>
        <Typography variant="caption" sx={{ color: '#9ca3af', mt: 1, display: 'block', textTransform: 'uppercase', letterSpacing: '0.05em', fontSize: '11px' }}>
          Beteiligt: Kai, Michael, Moritz, Joris, Pia, Alex, Jürgen
        </Typography>
      </Paper>
      <Box sx={{ flexGrow: 1, m: 2, mt: 2 }}>
        <ReactFlow
          nodes={nodes}
          edges={edges}
          onNodesChange={onNodesChange}
          onEdgesChange={onEdgesChange}
          onConnect={onConnect}
          fitView
          attributionPosition="bottom-left"
        >
          <Controls />
          <MiniMap
            nodeColor={(node) => {
              return node.style?.background || '#ffffff';
            }}
            maskColor="rgba(0, 0, 0, 0.05)"
          />
          <Background variant="dots" gap={16} size={1} color="#e5e7eb" />
        </ReactFlow>
      </Box>
    </Box>
  );
}

export default ProcessFlow;
